// Shared formatting helper — "Last, First" everywhere a child's name
// appears in roster-style lists so directors can scan alphabetically by
// last name without having to mentally re-sort.
export function formatChildName(c) {
  if (!c) return "";
  const last = (c.last_name || "").trim();
  const first = (c.first_name || "").trim();
  if (last && first) return `${last}, ${first}`;
  return last || first || "";
}
